<template>
  <div class="dss-header mb-8">
    <h2 class="standard-layout__heading">{{ $ucfirst($t("dss.dss")) }}</h2>
    <div class="dss-header__controls">
      <v-btn
        class="ml-4"
        color="primary"
        x-large
        text
        @click="$router.push({ name: 'DSSCardioMedication', params: { patientId: patientId } })"
        v-if="$route.name === 'DSSMedicationPrescription'"
      >
        <smart-icon
          icon="mdi-pencil-outline"
          :iconColor="this.$color.coro['primary-500']"
          class="mr-2"
        />
        {{ $ucfirst($t("dss.editPrescription")) }}
      </v-btn>
      <v-btn
        class="ml-4"
        text
        color="primary"
        x-large
        @click="saveAndExit"
        v-else
        :disabled="disableSaveButton"
      >
        <smart-icon
          icon="mdi-content-save-outline"
          :iconColor="this.$color.coro['primary-500']"
          class="mr-2"
        />
        {{ $ucfirst($t('general.close', {catalog: 'app_mobile'})) }}
      </v-btn>
      <v-btn
        x-large
        text
        :disabled="$store.getters['dss/unhandledMedicationRecommendations'].length !== 0"
        @click="printPrescription('GP')"
        class="ml-4"
      >
        <smart-icon
          icon="mdi-printer"
          class="mr-2"
        />
        {{ $ucfirst($t("dss.printCaregiver")) }}
      </v-btn>
      <v-btn
        text
        x-large
        :disabled="$store.getters['dss/unhandledMedicationRecommendations'].length !== 0"
        @click="printPrescription('PATIENT')"
        class="ml-4"
      >
        <smart-icon
          icon="mdi-printer"
          class="mr-2"
        />
        {{ $ucfirst($t("dss.printPatient")) }}
      </v-btn>
      <v-btn
          text
          x-large
          @click="refreshAlgorithm"
          class="ml-4"
          v-if="showAlgorithmRefreshButton"
      >
        <smart-icon
            icon="mdi-database-refresh-outline"
            class="mr-2"
        />
        Refresh Algorithm
      </v-btn>
    </div>
  </div>
</template>

<script>
import SmartIcon from "./SmartIcon.vue";
import { mapGetters } from "vuex";

/**
 * Component DSSHeader.vue
 *
 * @module DSSHeader
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSSHeader.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "DSSHeader",
  components: {
    SmartIcon,
  },
  data() {
    return {}
  },
  props: {
    editPrescription: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      schedulesToBeDeleted: "dss/schedulesToBeDeleted"
    }),
    showAlgorithmRefreshButton: function(){
      return this.$store.state.dss?.DSSMedicationSchedules?.[0]?.algorithm &&
          this.$route.name === 'DSSCardioMedication' &&
          this.$store.getters['isTestingEnvironment']
    },
    disableSaveButton() {
      return !!this.schedulesToBeDeleted
    }
  },
  methods: {
    saveAndExit(){
      this.$app.eventBus.$emit('DSSHeader.saveAndExit', true);
    },
    async printPrescription(type) {
      const success =  await this.$app.patientManager.printPrescription(type, this.patientId);

      if (success) {
        this.$toasted.show(this.$ucfirst(this.$t('dss.sentToPrinter')), {
          type : 'success',
          icon : 'check',
          position: 'bottom-center',
        });
      }
    },
    refreshAlgorithm(){
      console.clear();
      this.$store.dispatch('dss/getDSSMedicationSchedules', {
        forceRefresh : true
      })

      this.$store.dispatch('patientSummary/removeUnsaved');
    }
  },
};
</script>

<style lang="scss">
.dss-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
